import { render, staticRenderFns } from "./Ban.vue?vue&type=template&id=922d3ca6&scoped=true&"
import script from "./Ban.vue?vue&type=script&lang=js&"
export * from "./Ban.vue?vue&type=script&lang=js&"
import style0 from "./Ban.vue?vue&type=style&index=0&id=922d3ca6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922d3ca6",
  null
  
)

export default component.exports